import {WeaLocaleProvider} from 'ecCom'
const getLabel = WeaLocaleProvider.getLabel
export default {
    listBtns: {
        "1": {
            type: 37,
            isSingle: false,
            title: `${getLabel(22243, '文档')}`,
            customized: true,
            icon: "icon-coms-doc",
            iconBgcolor: "#f14a2d"
        },
        "2": {
            type: 152,
            isSingle: false,
            title: `${getLabel(30045, '流程')}`,
            customized: true,
            icon: "icon-coms-workflow",
            iconBgcolor: "#0079de"
        },
        "4": {
            type: 18,
            isSingle: false,
            title: `${getLabel(136, '客户')}`,
            customized: true,
            icon: "icon-coms-crm",
            iconBgcolor: "#96358a"
        },
        "3": {
            type: 135,
            isSingle: false,
            title: `${getLabel(101, '项目')}`,
            customized: true,
            icon: "icon-coms-project",
            iconBgcolor: "#217346"
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/constants/BrowserDict.js